/*
 * @Author: hehaishen
 * @Date: 2019-06-14 22:03:02
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2019-12-27 17:56:39
 * @Description:
 */
const routerArr = [{
        path: 'accountManagement',
        component: (resolve) => require(["page/systemManagement/accountManagement/index"], resolve),
        meta: { show: '1110', title: '账号管理', source: '11c2' },
    },
    {
        path: 'funcSet',
        component: (resolve) => require(["page/systemManagement/funcSet/index"], resolve),
        meta: { show: '1110', title: '功能配置', source: '11c2' },
        redirect: '/home/funcSet/customTemplate',
        children: [{
                path: 'customTemplate',
                component: (resolve) => require(["page/systemManagement/funcSet/customTemplate"], resolve),
                meta: { show: '1110', title: '自定义模板', source: '11c2' },
            },
            {
                path: 'standardFunc',
                component: (resolve) => require(["page/systemManagement/funcSet/standardFunc"], resolve),
                meta: { show: '1110', title: '标准功能', source: '11c2' },
            },
            {
                path: 'funcManagement',
                component: (resolve) => require(["page/systemManagement/funcSet/funcManagement"], resolve),
                meta: { show: '1110', title: '功能管理', source: '11c2' },
            },
            {
                path: 'funcGroupSet',
                component: (resolve) => require(["page/systemManagement/funcSet/funcGroupSet"], resolve),
                meta: { show: '1110', title: '编辑功能项', source: '11c2' },
            },
            {
                path: 'addTemplate',
                component: (resolve) => require(["page/systemManagement/funcSet/addTemplate"], resolve),
                meta: { show: '1110', title: '新增模板', source: '11c2' },
            },
            {
                path: 'funcGroupDetail',
                props: true,
                component: (resolve) => require(["page/systemManagement/funcSet/funcGroupDetail"], resolve),
                meta: { show: '1110', title: '查看功能组', source: '11c2' },
            },
            {
                path: 'roleList',
                component: (resolve) => require(["page/systemManagement/funcSet/roleManage/list"], resolve),
                meta: { show: '1110', title: '角色管理', source: '11c2' },
            },
        ],
    },
    {
        path: 'addRolePerMission',
        component: (resolve) => require(["page/systemManagement/accountManagement/addRolePermission"], resolve),
        meta: { show: '1110', title: '新增角色', source: '11c2' },
    },
    {
        path: 'app-management',
        component: (resolve) => require(["page/systemManagement/app-management"], resolve),
        meta: { show: '1110', title: '应用管理', source: '11c3' }
    },
    {
        path: 'app-management-add',
        component: (resolve) => require(["page/systemManagement/app-add"], resolve),
        meta: { show: '1110', title: '新增应用', source: '11c3' }
    },
    {
        path: 'app-versions',
        component: (resolve) => require(["page/systemManagement/app-versions"], resolve),
        meta: { show: '1110', title: '版本管理', source: '11c3' }
    },
    {
        name: 'app-versions-add',
        path: 'app-versions-add',
        component: (resolve) => require(["page/systemManagement/app-versions-add"], resolve),
        meta: { show: '1110', title: '增加版本', source: '11c3' }
    },
    {
        path: 'sys-feedback',
        component: (resolve) => require(["page/systemManagement/sys-feedback"], resolve),
        meta: { show: '1110', title: '建议反馈', source: '11c4' }
    },
    {
        path: 'sys-framework',
        component: (resolve) => require(["page/systemManagement/framework"], resolve),
        meta: { show: '1110', title: '组织架构', source: '11c4' }
    },
    {
        path: 'debugToolAccount',
        component: (resolve) => require(["page/systemManagement/debugToolAccount/index.vue"], resolve),
        meta: { show: '1110', title: '调试工具账号管理', source: '11c4' }
    }
];

export default routerArr;



// WEBPACK FOOTER //
// ./src/container/pages/systemManagement/_res.js